export default __webpack_public_path__ + "static/media/trade_hk_02.8049096e.png";